export const SIGN_IN_MOCK = {
    success: [{
        accessToken: 'ACCESS',
        refreshToken: 'REFRESH',
        expiresIn: 60,
        fbSession: 'fbSession',
    }],
    failures: []
};

export const REVOCATION_MOCK = {
    success: [],
    failures: [{
        code: 0,
        errorMessage: 'FAILURE'
    }],
};
